import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, AfterContentInit, AfterViewInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { map } from 'rxjs/operators';

import { ListItem, SitefinityPortalMenu, SitefinityMenuItem, CustomFormControl, NotificationService, Notification, ADPResourceService as ResourceService } from 'digital-core';


@Component({
  selector: 'footer-layout',
  templateUrl: './footer-layout.component.html',
  styleUrls: ['./footer-layout.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class FooterLayoutComponent implements OnInit {

  @Output()
  languageChangedEvent = new EventEmitter();
  languages: ListItem[];
  public languageFg: UntypedFormGroup;
  portalFooter: SitefinityPortalMenu;
  useMenus = false;

  constructor(public resourceService: ResourceService,
    private notificationService: NotificationService) { }

  ngOnInit() {

    this.languageFg = new UntypedFormGroup({
      languageDropDown: new CustomFormControl(),
    });
    let menuSetting = this.resourceService.getPortalSetting("Show_Footer_Menus");

    if (menuSetting) {
      this.useMenus = JSON.parse(this.resourceService.getPortalSetting("Show_Footer_Menus").Value);
    }

    if (this.useMenus) {
      // load footer options
      this.loadFooterMenu();
    }

    let scope = this;
    scope.languageFg.get('languageDropDown').disable();
    // check if languages are already in local storage, if not then load it
    if (!localStorage.getItem("current_language") || !localStorage.getItem("available_languages")) {
      scope.resourceService.getListItemResource('Global_List_FooterLanguage')
        .pipe(
          map(res => {
            return res.map(languageItem => {
              return new ListItem(languageItem.Id, languageItem.Key, languageItem.Value);
            });
          })
        ).subscribe(
          response => {
            // check response
            if (response && response.length > 0) {
              response.forEach(element => {
                element.Value = element.Value.toUpperCase();
                element.Key = element.Key.toUpperCase();
              });
              // set current language and available languages
              localStorage.setItem('current_language', response[0].Value.toLowerCase());
              localStorage.setItem('available_languages', JSON.stringify(response));

              scope.languages = response;
              scope.languageFg.get('languageDropDown').setValue(response[0].Key);
            }

          },
          error => {
            this.notificationService.logError(error);
          }
        );
    } else { // load languages from local storage
      this.languages = JSON.parse(localStorage.getItem("available_languages"));
      this.languageFg.get('languageDropDown').setValue(this.languages[0].Key);
    }


  }

  getResourceObject(name: string, type: string, namespace = null) {
    namespace = namespace ? namespace : 'FooterLayout';
    let title = namespace + '_' + type + '_' + name;
    let resourceValue = this.resourceService.getResourceObject(title);
    return resourceValue;
  }

  onLanguageSelectorChange(event: any) {
    // update current language on local storage
    // localStorage.setItem('current_language', this.languageFg.get('languageDropDown').value);
    // // reload resources
    // this.languageChangedEvent.emit("Language changed");
    // this.loadFooterMenu();
    // this.updateLanguages();
    // // reload
    // window.location.reload();
  }

  loadFooterMenu() {
    this.resourceService.getPortalMenus("Portal_Footer").subscribe(
      // get portal footer
      response => {
        this.portalFooter = response;

        if (
          !this.portalFooter ||
          !this.portalFooter.MenuItems ||
          this.portalFooter.MenuItems.length <= 0
        ) {
          this.notificationService.showError(
            new Notification(
              "There was an error loading the resources from the page",
              "",
              true
            )
          );
        }

      },
      error => { }
    );

  }

  getMenuByOrder(order: number): SitefinityMenuItem {
    // check if footer menu was already loaded
    if (!this.portalFooter) {
      return null;
    }

    // get menu item by provided order
    return this.portalFooter.MenuItems.find(x => x.Order === order);
  }
}
